import "simplebar"
import "simplebar/dist/simplebar.css"
import SimpleBar from "simplebar"

export const simplebarMeta = (container: HTMLDivElement) => {
  if (typeof window === "undefined") return

  const forceVisible = container.dataset.scrollAxes === "both" ? "x" : false
  const instance =
    SimpleBar.instances.get(container) ??
    new SimpleBar(container, {
      autoHide: false,
      forceVisible,
    })
  let frame: number | null = null
  const recalculate = () => {
    if (frame !== null && typeof window.cancelAnimationFrame === "function") {
      window.cancelAnimationFrame(frame)
    }

    if (typeof window.requestAnimationFrame === "function") {
      frame = window.requestAnimationFrame(() => {
        frame = null
        instance.recalculate()
      })
    } else {
      instance.recalculate()
    }
  }
  recalculate()

  if (typeof queueMicrotask === "function") {
    queueMicrotask(recalculate)
  }

  let observer: ResizeObserver | null = null

  if (typeof ResizeObserver !== "undefined") {
    observer = new ResizeObserver(recalculate)
    observer.observe(container)
    observer.observe(instance.getScrollElement())
    observer.observe(instance.getContentElement())
  }

  return {
    destroy: () => {
      if (frame !== null) {
        window.cancelAnimationFrame(frame)
      }

      observer?.disconnect()
      instance.unMount()
    },
  }
}
